/**
 * TELA ABERTA DURANTE UM DEPLOY. Cada publicação troca o nome dos arquivos de código; a aba que já estava aberta ainda pede
 * os nomes antigos quando a pessoa navega para uma parte que ainda não tinha baixado, o servidor devolve a página no lugar
 * do arquivo, e a tela fica preta ("Failed to fetch dynamically imported module"). Aqui a página se recarrega sozinha, uma
 * vez, e volta já na versão nova, no mesmo endereço. A trava de 30 segundos impede laço se o erro for outro.
 */
const KEY = 'rr.recarregou';
const STALE = /dynamically imported module|Importing a module script failed|module script.*MIME type|Unable to preload CSS/i;

export function reloadOnStaleBuild(): void {
  if (typeof window === 'undefined') return;
  const reload = () => {
    try {
      const last = Number(sessionStorage.getItem(KEY) ?? 0);
      if (Date.now() - last < 30_000) return;
      sessionStorage.setItem(KEY, String(Date.now()));
    } catch { /* sem storage, recarrega mesmo assim */ }
    window.location.reload();
  };
  // o Vite avisa quando uma parte da tela não pôde ser baixada
  window.addEventListener('vite:preloadError', (e) => { e.preventDefault(); reload(); });
  // e a reserva, para o navegador que só mostra o erro
  window.addEventListener('error', (e) => { if (STALE.test(String(e.message ?? ''))) reload(); });
  window.addEventListener('unhandledrejection', (e) => { if (STALE.test(String((e.reason as { message?: string } | undefined)?.message ?? e.reason ?? ''))) reload(); });
}
